import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

import { formatByType } from "./formatters";

// Metrics where a rise is bad news. Everything else reads "up = good", so the delta
// chevron is coloured against intent rather than against sign alone.
const LOWER_IS_BETTER = new Set(["bounce_rate"]);

const Delta = ({ kpiKey, deltaPct }) => {
  if (deltaPct === null || deltaPct === undefined) {
    return (
      <span className="flex items-center gap-1 text-xs text-on-surface-variant">
        <Minus className="w-3 h-3" />
        No prior data
      </span>
    );
  }

  const rising = deltaPct > 0;
  const flat = deltaPct === 0;
  const good = LOWER_IS_BETTER.has(kpiKey) ? !rising : rising;
  const Icon = rising ? ArrowUpRight : ArrowDownRight;
  const tone = flat ? "text-on-surface-variant" : good ? "text-emerald-600" : "text-error";

  return (
    <span className={`flex items-center gap-1 text-xs font-semibold ${tone}`}>
      {flat ? <Minus className="w-3 h-3" /> : <Icon className="w-3 h-3" />}
      {Math.abs(deltaPct).toFixed(1)}%
      <span className="font-normal text-on-surface-variant">vs prior period</span>
    </span>
  );
};

const KpiGrid = ({ kpis = [] }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
    {kpis.map((kpi) => (
      <div
        key={kpi.key}
        className="bg-surface-container-low rounded-2xl p-4 border border-surface-container-high"
      >
        <p className="text-xs font-semibold uppercase tracking-wide text-on-surface-variant">
          {kpi.label}
        </p>
        <p className="font-headline text-2xl font-bold text-on-surface mt-1">
          {formatByType(kpi.value, kpi.format)}
        </p>
        <div className="mt-1">
          <Delta kpiKey={kpi.key} deltaPct={kpi.delta_pct} />
        </div>
      </div>
    ))}
  </div>
);

export default KpiGrid;
